<template>
  <transition-group
    name="fade"
    mode="out-in"
  >
    <nav
      key="navbar"
      class="navbar-wrapper sticky-top"
    >
      <navbar-logo></navbar-logo>
    </nav>
  </transition-group>
</template>

<script>
import NavbarLogo from '@/components/navbar/NavbarLogo.vue'

export default {
  name: 'NavbarResetPassword',
  components: {
    NavbarLogo
  }
}
</script>

<style scoped>
.navbar-wrapper {
  display: flex;
  padding: 16px;
  background-color: var(--color-neutral-100);
  min-height: 56px;
  box-shadow: 0px 2px 8px 0px rgba(51, 51, 51, 0.10);
}

@media screen and (min-width: 1024px) {
  .navbar-wrapper {
    padding: 10px 48px;
  }
}
</style>
